// ABOUTME: Carries the nodes the link contents of a node rebuilt at a date pointed to, as they stood then.
// ABOUTME: Null outside a node-at-date view, so the link fields keep searching the live hierarchy.

import { createContext } from 'react';

import type { NodeAtDateQuery } from '../graphql/nodeAtDate.generated';

export type HistoricalLinkedNode = {
    id: string;
    hierarchy: string;
    code: string;
    listName: string;
    disabled?: boolean | null;
    /** Present on the linked nodes of a node view, used to fill the link field table. */
    parent?: string;
    parentCode?: string;
    depth?: number;
    createdAt?: number;
    updatedAt?: number;
    contents?: NodeAtDateQuery['nodeAtDate']['linkedNodes'][number]['contents'];
};

/** The linked nodes keyed by `${hierarchy}-${id}`. */
export type HistoricalLinkedNodes = Map<string, HistoricalLinkedNode>;

export const historicalLinkedNodeKey = (hierarchy: string, id: string) => `${hierarchy}-${id}`;

export const toHistoricalLinkedNodes = (nodes: HistoricalLinkedNode[]): HistoricalLinkedNodes =>
    new Map(nodes.map(node => [historicalLinkedNodeKey(node.hierarchy, node.id), node]));

export const HistoricalLinkedNodesContext = createContext<HistoricalLinkedNodes | null>(null);
